import type { ItilTranslationType } from 'api/itilGenius';

import type { ItilTranslationScope } from './types';

const prefix = 'itil-cache';

function cacheKey(ticketId: number, scope: ItilTranslationScope): string {
  return `${prefix}-${ticketId}-${scope}`;
}

type ItilGeniusReader = {
  GetTranslationByType: (
    ticketId: number,
    translationType: ItilTranslationType
  ) => Promise<string | null>;
};

/** Consulta API primero; usa caché de sesión solo como fallback offline. */
export async function fetchItilTranslationPreferApi(
  itilGenius: ItilGeniusReader,
  ticketId: number,
  scope: ItilTranslationScope,
  translationType: ItilTranslationType
): Promise<string | null> {
  const fromApi = await itilGenius.GetTranslationByType(ticketId, translationType);
  if (fromApi) {
    setItilTranslationCache(ticketId, scope, fromApi);
    return fromApi;
  }
  return getItilTranslationCache(ticketId, scope);
}

export function setItilTranslationCache(
  ticketId: number,
  scope: ItilTranslationScope,
  text: string
): void {
  try {
    sessionStorage.setItem(cacheKey(ticketId, scope), text);
  } catch {
    // ignore quota errors
  }
}

export function getItilTranslationCache(
  ticketId: number,
  scope: ItilTranslationScope
): string | null {
  try {
    return sessionStorage.getItem(cacheKey(ticketId, scope));
  } catch {
    return null;
  }
}

export function clearItilTranslationCache(
  ticketId: number,
  scope?: ItilTranslationScope
): void {
  try {
    if (scope) {
      sessionStorage.removeItem(cacheKey(ticketId, scope));
      return;
    }
    (['description', 'creationComment', 'closing'] as ItilTranslationScope[]).forEach((s) => {
      sessionStorage.removeItem(cacheKey(ticketId, s));
    });
  } catch {
    // ignore
  }
}
